import { Layout } from "antd";
import { Content } from "antd/es/layout/layout";
import AppHeader from "./AppHeader";
import "./index.scss";

const Container = ({ children }: any) => {


  return (
    <Layout className="container">
      <AppHeader />
      <Content style={{ width: "100%", maxWidth: 1440, margin: "0 auto" }}>
        {children}
      </Content>
    </Layout>
  );
};

export default Container;
